import { EElementSize } from '../../types';
import { ESelectorTabSize } from '../../ui/selector-tab';

const WrapperSizeMap: Record<ESelectorTabSize, EElementSize> = {
  [EElementSize.L]: EElementSize.M,
  [EElementSize.M]: EElementSize.S,
};

export const useWrapperSize = (size: ESelectorTabSize) => WrapperSizeMap[size];
